import React from 'react';
import { Skeleton } from 'antd';
import { usePlan } from '../../../hooks/usePlan';
import { FeatureKey } from '../../../constants/features';
import { LockedFeature } from './LockedFeature';

interface Props {
  children: React.ReactNode;
  featureKey: FeatureKey;
  fallback?: React.ReactNode;
  /** ロック時にインライン表示にする場合 true */
  inline?: boolean;
}

/**
 * プランに応じて子要素の表示可否を切り替える。
 * 利用不可のときは fallback、無指定なら LockedFeature を表示する。
 */
export const FeatureGate: React.FC<Props> = ({
  children,
  featureKey,
  fallback,
  inline,
}) => {
  const { canUse, isLoading } = usePlan();

  if (isLoading) {
    return <Skeleton active paragraph={false} />;
  }

  if (!canUse(featureKey)) {
    if (fallback !== undefined) {
      return <>{fallback}</>;
    }
    return <LockedFeature featureKey={featureKey} inline={inline} />;
  }

  return <>{children}</>;
};
